import React, { Fragment } from "react";
import TextField from "@material-ui/core/TextField";
import { isDisplayable } from "util/misc";
import { fieldExistsOnPlayType } from "games/utils";

const PlayTextInput = ({
  inputName,
  label,
  handleInputChange,
  play,
  multiline,
  classes,
  tabIndex
}) => {
  const formatValue = (val) => {
    return isDisplayable(val) ? val : "";
  };

  return (
    <Fragment>
      {fieldExistsOnPlayType(play.playType, inputName) && (
        <TextField
          id={inputName}
          label={label}
          onChange={(event) => handleInputChange(event, inputName)}
          value={formatValue(play[inputName])}
          variant="filled"
          multiline={multiline}
          className={classes.input}
          InputProps={
            tabIndex || tabIndex === 0 ? { inputProps: { tabIndex } } : {}
          }
        />
      )}
    </Fragment>
  );
};

export default PlayTextInput;
